import DATATABLE_TRANSLATIONS from "./datatable_translations";

export default class CaregiversDataTable {
  constructor() {
    $(document).ready(function() {
      showCaregiversTable();
    });

    $(document).on("turbo:render", function() {
      showCaregiversTable();
    });

    function showCaregiversTable() {
      $('#caregivers-datatable').dataTable({
        "order": [],
        "columnDefs": [ {
          "targets"  : 'no-sort',
          "orderable": false,
        }],
        "language": DATATABLE_TRANSLATIONS,
        "processing": true,
        "serverSide": true,
        "ajax": {
          "url": $('#caregivers-datatable').data('source')
        },
        "pagingType": "full_numbers",
        "columns": [
          {"data": "first_name"},
          {"data": "last_name"},
          {"data": "email"},
          {"data": "actions"}
        ]
        // pagingType is optional, if you want full pagination controls.
        // Check dataTables documentation to learn more about
        // available options.
      });
    }
  }
}
